<template>
  <div id="text-to-input" ref="text-to-input-wrapper">
    <label v-if="label" v-html="label"></label>
    <div
      class="text-wrapper"
      :style="{
        cursor: canChange ? 'pointer' : 'default',
        height: this.height
      }"
      v-if="showText"
      @click="switchElement"
    >
      <div :style="`font-siz: ${this.fontSize}`">
        {{ textValue }}
      </div>
    </div>
    <input
      @blur="switchElement"
      v-if="!showText"
      name="input"
      ref="text-to-input"
      v-model="inputText"
      :style="`height: ${this.height}; font-siz: ${this.fontSize}`"
      :type="inputType"
      :placeholder="placeholder"
    />
  </div>
</template>

<script>
export default {
  name: "TextToInput",
  props: {
    value: {
      type: [String, Number],
      required: false,
      default: ""
    },
    canChange: {
      type: Boolean,
      required: false,
      default: true
    },
    type: {
      type: String,
      required: false,
      default: "text"
    },
    label: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    fontSize: {
      type: String,
      required: false,
      default: "15px"
    },
    width: {
      type: String,
      required: false,
      default: "100%"
    },
    height: {
      type: String,
      required: false,
      default: "30px"
    },
    textValue: {
      type: String,
      required: false,
      default: ""
    }
  },
  components: {},
  data() {
    return {
      inputText: this.value,
      inputType: "text",
      showText: true
    };
  },
  mounted() {
    this.inputType = this.type;
    this.$refs["text-to-input-wrapper"].style.width = this.width;
  },
  computed: {},
  watch: {
    showText() {
      if (this.showText) {
        this.$emit("input", this.inputText);
      }
    }
  },
  methods: {
    switchElement() {
      if (this.canChange) {
        this.showText = !this.showText;
        if (this.showText === false) {
          setTimeout(() => {
            this.$refs["text-to-input"].focus();
          }, 300);
        }
      }
    }
    // updateValue() {
    //   this.$emit("input", this.inputText);
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#text-to-input {
  position: relative;
  label {
    padding-left: 5px;
    font-size: 13px;
    margin: 0;
  }
  .text-wrapper {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    border-radius: 6px;
    padding: 0 12px 0 12px;
    outline: none;
    transition: all 1s;
    border: none;
    padding: 0 12px 0 12px;
  }

  input {
    height: 100%;
    width: 100%;
    border-radius: 6px;
    background: #f3f3f3;
    padding: 0 12px 0 12px;
    outline: none;
    transition: all 1s;
    border: none;
    // box-shadow: $input-shadow;
  }
}
</style>
